import vehicleService from '../../services/vehicleService/service';

export default {
    async getAllVehicles(search,page, limit) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await vehicleService.getAllVehicles(sanitizedSearch,page,limit);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    },
    async totalAllVehicles(search) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await vehicleService.totalAllVehicles(sanitizedSearch);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
}